
//Analytics
analytics.eventConfig.push(
    {
        "target": ".recommendations-view",
        "codeId": "psallr",
        "events": [
            // Search button
            {
                "eventTarget": ".buttons-container .dynamic-button.default",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "new search button",
                    "event": "navigation",
                    "eventType": "new search internal navigation click",
                    "parentName": "tabs",
                    "parentTitle": ""
                }
            },
            {
                "eventTarget": ".buttons-container .dynamic-button.btn-default",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "new search button",
                    "event": "navigation",
                    "eventType": "new search internal navigation click",
                    "parentName": "tabs",
                    "parentTitle": ""
                }
            },
            // Search button (in footer)
            {
                "eventTarget": ".button-container .button-search",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "new search button",
                    "event": "navigation",
                    "eventType": "new search internal navigation click",
                    "parentName": "tabs",
                    "parentTitle": ""
                }
            },
            // Print button
            {
                "eventTarget": ".recommendations-header .dynamic-button.btn-tertiary",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "elementText": "",
                    "elementType": "print button",
                    "event": "navigation",
                    "eventType": "print click",
                    "parentName": "tabs",
                    "parentTitle": ""
                }
            },
            // Buy online button
            {
                "eventTarget": ".dropdown.result-button .dropdown-item",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "buy online outbound link",
                    "event": "outbound",
                    "eventType": "buy online outbound click",
                    "highlyRec": "",
                    "parentName": "tabs",
                    "parentTitle": "",
                    "refinementCategory": "",
                    "starRating": "",
                    "titleText": ""
                }
            },

            // find in store
            {
                "eventTarget": ".ps-enabled.ps-button-label",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "find store link",
                    "event": "navigation",
                    "eventType": "find store internal navigation click",
                    "highlyRec": "",
                    "parentName": "tabs",
                    "parentTitle": "",
                    "refinementCategory": "",
                    "starRating": "",
                    "titleText": ""
                }
            },
            // no sellers
            {
                "eventTarget": ".ps-disabled.ps-button-label",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "find store link",
                    "event": "navigation",
                    "eventType": "find store internal navigation click",
                    "highlyRec": "",
                    "parentName": "tabs",
                    "parentTitle": "",
                    "refinementCategory": "",
                    "starRating": "",
                    "titleText": ""
                }
            },
            // Compare button
            {
                "eventTarget": ".button-container .block  .btn-tertiary:not(.outline).compare-button",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "elementText": "",
                    "elementType": "compare button",
                    "event": "navigation",
                    "eventType": "add product to compare click",
                    "highlyRec": "",
                    "parentName": "tabs",
                    "parentTitle": "",
                    "refinementCategory": "",
                    "starRating": "",
                    "titleText": ""
                }
            },
            // Buy in Store button
            {
                "eventTarget": ".btn-primary.outline[data-analytics]",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "buy in store link",
                    "event": "navigation",
                    "eventType": "buy in store internal navigation click",
                    "highlyRec": "",
                    "parentName": "tabs",
                    "parentTitle": "",
                    "refinementCategory": "",
                    "starRating": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".btn-tertiary.outline[data-analytics]",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "buy in store link",
                    "event": "navigation",
                    "eventType": "buy in store internal navigation click",
                    "highlyRec": "",
                    "parentName": "tabs",
                    "parentTitle": "",
                    "refinementCategory": "",
                    "starRating": "",
                    "titleText": ""
                }
            },
            // Product page button
            {
                "eventTarget": ".btn-secondary.outline[data-analytics]",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "product page button",
                    "event": "navigation",
                    "eventType": "recommended product internal navigation click",
                    "highlyRec": "",
                    "parentName": "tabs",
                    "parentTitle": "",
                    "refinementCategory": "",
                    "starRating": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".btn-tertiary:not(.outline).product-page-btn[data-analytics]",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "product page button",
                    "event": "navigation",
                    "eventType": "recommended product internal navigation click",
                    "highlyRec": "",
                    "parentName": "tabs",
                    "parentTitle": "",
                    "refinementCategory": "",
                    "starRating": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".btn-tertiary:not(.outline).button-mobile[data-analytics]",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "product page button",
                    "event": "navigation",
                    "eventType": "recommended product internal navigation click",
                    "highlyRec": "",
                    "parentName": "tabs",
                    "parentTitle": "",
                    "refinementCategory": "",
                    "starRating": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".btn-primary[data-analytics]:not(.outline):not(.dropdown-toggle):not(.compare-btn)",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "product page button",
                    "event": "navigation",
                    "eventType": "recommended product internal navigation click",
                    "highlyRec": "",
                    "parentName": "tabs",
                    "parentTitle": "",
                    "refinementCategory": "",
                    "starRating": "",
                    "titleText": ""
                }
            },
            // Product page link
            {
                "eventTarget": ".result-list-title",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "product link",
                    "event": "navigation",
                    "eventType": "recommended product internal navigation click",
                    "highlyRec": "",
                    "parentName": "tabs",
                    "parentTitle": "",
                    "refinementCategory": "",
                    "starRating": "",
                    "titleText": ""
                }
            },
            // Product page image
            {
                "eventTarget": ".brand-image",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "product image",
                    "event": "navigation",
                    "eventType": "recommended product internal navigation click",
                    "highlyRec": "",
                    "parentName": "tabs",
                    "parentTitle": "",
                    "refinementCategory": "",
                    "starRating": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".additional-image",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "product image",
                    "event": "navigation",
                    "eventType": "recommended product internal navigation click",
                    "highlyRec": "",
                    "parentName": "tabs",
                    "parentTitle": "",
                    "refinementCategory": "",
                    "starRating": "",
                    "titleText": ""
                }
            },
            // Accordion
            {
                "eventTarget": "notes .accordion.collapsed .collapse",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "elementText": "",
                    "elementType": "accordion expansion box",
                    "event": "navigation",
                    "eventType": [
                        {
                            "rule": "true",
                            "value": "accordion expansion click"
                        },
                    ],
                    "parentName": "tabs",
                    "parentTitle": ""
                }
            },
            {
                "eventTarget": "notes .collapse.show",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "elementText": "",
                    "elementType": "accordion expansion box",
                    "event": "navigation",
                    "eventType": [
                        {
                            "rule": "true",
                            "value": "accordion collapse click"
                        }

                    ],
                    "parentName": "tabs",
                    "parentTitle": ""
                }
            },
            {
                "eventTarget": ".tab-filter-items .nav-link",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "elementText": "",
                    "elementType": "tabs",
                    "event": "navigation",
                    "eventType": "tab click"
                }
            },
            // Order by
            {
                "eventTarget": "bazaar-filter .bazaar-tab",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "elementText": "",
                    "elementType": "order by button",
                    "event": "navigation",
                    "eventType": "order by click",
                    "parentName": "tabs",
                    "parentTitle": ""
                }
            },
            // Show/Hide product type
            {
                "eventTarget": ".showTop",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "elementText": "",
                    "elementType": "recommendation list refinement",
                    "event": "navigation",
                    "eventType": [
                        {
                            "rule": "true",
                            "value": "show products click"
                        },
                        {
                            "rule": "true",
                            "value": "hide products click"
                        }
                    ],
                    "parentName": "tabs",
                    "parentTitle": ""
                }
            },
            {
                "eventTarget": ".drop-select select",
                "eventType": "change",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "elementText": "",
                    "elementType": "recommendation list refinement dropdown",
                    "event": "navigation",
                    "eventType": "product category dropdown refinement click",
                    "parentName": "tabs",
                    "parentTitle": "",
                    "refinementCategory": ""
                }
            },

        ]
    },
      // Product comparison flyout
      {
        "target": ".recommendations-view",
        "events": [
            {
                "eventTarget": ".compare-container .cross",
                "eventType": "click",
                "tags": {
                    "componentId": "pdtc",
                    "componentName": "product comparison",
                    "elementText": "",
                    "elementType": "x out button",
                    "event": "navigation",
                    "eventType": "remove product click"
                }
            },
            {
                "eventTarget": ".compare-container .clear",
                "eventType": "click",
                "tags": {
                    "componentId": "pdtc",
                    "componentName": "product comparison",
                    "elementText": "",
                    "elementType": "clear all button",
                    "event": "navigation",
                    "eventType": "clear all products click"
                }
            },
            {
                "eventTarget": ".button-compare .compare-btn",
                "eventType": "click",
                "tags": {
                    "componentId": "pdtc",
                    "componentName": "product comparison",
                    "elementText": "",
                    "elementType": "compare button",
                    "event": "navigation",
                    "eventType": "compare internal navigation click"
                }
            }
        ]
    }
);

(function () {
    $(window).on('load', function () {
        psTabsClick();
        initalLoadComplete();
        psButtonClick();
    });


    setTimeout(function () {
        if (($('.ps-widget') && $('.ps-widget').length) || ($('.ps-container') && $('.ps-container').length) || ($('.ps-lightbox') && $('.ps-lightbox').length)) {
            var setTimerInterval = setInterval(function () {
                if (($('.ps-widget') && $('.ps-widget').length) || ($('.ps-container') && $('.ps-container').length) || ($('.ps-lightbox') && $('.ps-lightbox').length)) {
                    var getPriceSpider = window.dataLayer;
                    getPriceSpider.forEach(function (item, index) {
                        if (item.event === 'pricespider' && (item.eventType === 'lightbox loaded' || item.eventType == 'location set' || item.eventType == 'embedded loaded' || item.eventType == 'online seller click' || item.eventType == 'get directions click' || item.eventType == 'phone number click')) {
                            item.componentId = item.componentId == undefined ? "prs" : item.componentId;
                            item.componentName = item.componentName.includes("pricespider - ") ? item.componentName : "pricespider - " + item.componentName;
                        }
                    });
                } else {
                    clearInterval(setTimerInterval);
                }
            }, 1000);
        }
        $('.ps-widget.product-details-button .ps-button-label').click(function (e) {
            setTimeout(function () {
                if ($('.ps-container.ps-lightbox') && $('.ps-container.ps-lightbox').length) {
                    var getPriceSpider = window.dataLayer;
                    getPriceSpider.forEach(function (item, index) {
                        if (item.event === 'pricespider' && item.eventType === 'lightbox loaded') {
                            item.elementText = e.target.innerHTML.toLowerCase();
                        }
                    });
                }
            }, 5000);
        });
        $('.ps-widget .ps-button-label').click(function (e) {
            setTimeout(function () {
                if ($('.ps-container.ps-lightbox') && $('.ps-container.ps-lightbox').length) {
                    var getPriceSpider = window.dataLayer;
                    getPriceSpider.forEach(function (item, index) {
                        if (item.event === 'pricespider' && item.eventType === 'lightbox loaded') {
                            item.elementText = e.target.innerHTML.toLowerCase();
                        }
                        if (item.event === 'pricespider' && (item.eventType === 'lightbox loaded' || item.eventType == 'location set' || item.eventType == 'embedded loaded' || item.eventType == 'online seller click' || item.eventType == 'get directions click' || item.eventType == 'phone number click')) {
                            item.componentId = item.componentId == undefined ? "prs" : item.componentId;
                            item.componentName = item.componentName.includes("pricespider - ") ? item.componentName : "pricespider - " + item.componentName;
                        }
                    });
                }
            }, 5000);
        });
        $('.ps-map-location-textbox').on('keypress', function (e) {
            if (e.originalEvent.keyCode == 13) {
                setTimeout(function () {
                    var getPriceSpider = window.dataLayer;
                    getPriceSpider.forEach(function (item, index) {
                        if (item.event === 'pricespider' && (item.eventType === 'lightbox loaded' || item.eventType == 'location set' || item.eventType == 'embedded loaded' || item.eventType == 'online seller click' || item.eventType == 'get directions click' || item.eventType == 'phone number click')) {
                            item.componentId = item.componentId == undefined ? "prs" : item.componentId;
                            item.componentName = item.componentName.includes("pricespider - ") ? item.componentName : "pricespider - " + item.componentName;
                        }
                    });
                }, 5000);
            }
        });
        $('.ps-map-location-button').on('click', function (e) {
            setTimeout(function () {
                var getPriceSpider = window.dataLayer;
                getPriceSpider.forEach(function (item, index) {
                    if (item.event === 'pricespider' && (item.eventType === 'lightbox loaded' || item.eventType == 'location set' || item.eventType == 'embedded loaded' || item.eventType == 'online seller click' || item.eventType == 'get directions click' || item.eventType == 'phone number click')) {
                        item.componentId = item.componentId == undefined ? "prs" : item.componentId;
                        item.componentName = item.componentName.includes("pricespider - ") ? item.componentName : "pricespider - " + item.componentName;
                    }
                });
            }, 5000);
        });
        $('.ps-address span a[href^="tel:"]').on('click', function (e) {
            setTimeout(function () {
                var getPriceSpider = window.dataLayer;
                getPriceSpider.forEach(function (item, index) {
                    if (item.event === 'pricespider' && (item.eventType === 'lightbox loaded' || item.eventType == 'location set' || item.eventType == 'embedded loaded' || item.eventType == 'online seller click' || item.eventType == 'get directions click' || item.eventType == 'phone number click')) {
                        item.componentId = item.componentId == undefined ? "prs" : item.componentId;
                        item.componentName = item.componentName.includes("pricespider - ") ? item.componentName : "pricespider - " + item.componentName;
                    }
                });
            }, 5000);
        });
        $('.ps-get-directions-button').on('click', function (e) {
            setTimeout(function () {
                var getPriceSpider = window.dataLayer;
                getPriceSpider.forEach(function (item, index) {
                    if (item.event === 'pricespider' && (item.eventType === 'lightbox loaded' || item.eventType == 'location set' || item.eventType == 'embedded loaded' || item.eventType == 'online seller click' || item.eventType == 'get directions click' || item.eventType == 'phone number click')) {
                        item.componentId = item.componentId == undefined ? "prs" : item.componentId;
                        item.componentName = item.componentName.includes("pricespider - ") ? item.componentName : "pricespider - " + item.componentName;
                    }
                });
            }, 5000);
        });
        $('.ps-online-seller-button').on('click', function (e) {
            setTimeout(function () {
                var getPriceSpider = window.dataLayer;
                getPriceSpider.forEach(function (item, index) {
                    if (item.event === 'pricespider' && (item.eventType === 'lightbox loaded' || item.eventType == 'location set' || item.eventType == 'embedded loaded' || item.eventType == 'online seller click' || item.eventType == 'get directions click' || item.eventType == 'phone number click')) {
                        item.componentId = item.componentId == undefined ? "prs" : item.componentId;
                        item.componentName = item.componentName.includes("pricespider - ") ? item.componentName : "pricespider - " + item.componentName;
                    }
                });
            }, 5000);
        });
    }, 5000);
    function psTabsClick() {
        if ($('.ps-tabs').length > 0) {
            $(".ps-tabs").click(function () {
                if ($('meta[name="ps-account"]').length > 0) {
                    PriceSpider.rebind();
                }
            });
        }
    }
    function psButtonClick() {
        if ($('.showTop').length > 0) {
            $('.showTop').click(function () {
                if ($('meta[name="ps-account"]').length > 0) {
                    PriceSpider.rebind();
                }
            });
        }
    }

    $(window).resize(function () {
        setTimeout(function () {
            if ($(".ps-widget").length > 0 && PriceSpider) {
                PriceSpider.rebind();
            }
        }, 500);
    });

    $(document).ready(function () {
        $('.promotion-details .promotion-expiration svg.tag').attr('tabindex', '-1');
        $('.promotion-details .promotion-expiration svg.tag path').attr('tabindex', '-1');
        setTimeout(function () {
            var getPriceSpider = window.dataLayer;
            getPriceSpider.forEach(function (item, index) {
                if (item.event === 'pricespider' && (item.eventType === 'lightbox loaded' || item.eventType == 'location set' || item.eventType == 'embedded loaded' || item.eventType == 'online seller click' || item.eventType == 'get directions click' || item.eventType == 'phone number click')) {
                    item.componentId = item.componentId == undefined ? "prs" : item.componentId;
                    item.componentName = item.componentName.includes("pricespider - ") ? item.componentName : "pricespider - " + item.componentName;
                }
            });
        }, 5000);
    });

}(window.jQuery));

